export default theme => ({
  listRow: {
    cursor: 'auto !important',
    "&:hover *": {
      backgroundColor: 'white'
    }
  },
  alert: {
    background: theme.palette.secondary.main,
    "& *": {
      color: theme.palette.white.main,
      fontWeight: 500,
    },
    "&:hover *": {
      color: theme.palette.primary.main,
      fontWeight: "unset",
    },
  },
  alertText: {
    textTransform: "uppercase",
    fontSize: 15,
  },
  alertLink: {
    textDecoration: "underline !important",
  },
  statusKo: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
    textTransform: "uppercase",
  },
  code: {
    color: theme.palette.disabled.main,
    fontSize: theme.textSizes[0],
  },
  title: {
    fontWeight: 500,
  },
});
